import { FC, ReactNode, useRef } from 'react';
import { Dialog } from '@headlessui/react';
import styles from './bt-welcome-modal.module.scss';

type Props = {
  chip: string,
  title: string,
  meta?: string,
  lead?: string,
  visual?: ReactNode,
  cta: { label: string, onClick: () => void },
  closeLabel: string,
  onDismiss: () => void,
};

const BtWelcomeModal: FC<Props> = ({ chip, title, meta, lead, visual, cta, closeLabel, onDismiss }) => {
  const ctaRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog open onClose={onDismiss} initialFocus={ctaRef} className={styles.overlay}>
      <Dialog.Panel className={styles.card}>
        <button className={styles.closeBtn} onClick={onDismiss} aria-label={closeLabel}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        </button>

        {visual && <div className={styles.visual}>{visual}</div>}

        <div className={styles.body}>
          <div className={styles.eyebrow}>
            <span className={styles.chip}>{chip}</span>
            {meta && <span className={styles.meta}>{meta}</span>}
          </div>
          <Dialog.Title as="h2" className={styles.title}>{title}</Dialog.Title>
          {lead && <p className={styles.lead}>{lead}</p>}
          <button ref={ctaRef} className={styles.cta} onClick={cta.onClick}>
            {cta.label}
          </button>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

export default BtWelcomeModal;
